
/**
 * Setup a player object.
 *
 * This is generally a user controlled Skier.
 * A player extends the Skiers properties and methods.
 *
 * @param  {Object} game  The Phaser Game object.
 * @param  {Number} x     The player x position.
 * @param  {Number} y     The player y position.
 * @param  {Object} group The player display group.
 */
Game.Prefabs.EffectRocketBoots = function( game, x, y ) {

	// Call parent class.
	Game.Prefabs.Effect.call( this, game, x, y, 'effect-dust-jump', Game.Utils.Layers.layers.groupElements );

	this.animations.add(
		'explode',
		[ 18, 19, 20, 21 ],
		6,
		false
	);

	this.anchor.setTo( 0.5, -0.4 );

	this.explode();

};


Game.Prefabs.EffectRocketBoots.prototype = Object.create( Game.Prefabs.Effect.prototype );


Game.Prefabs.EffectRocketBoots.constructor = Game.Prefabs.EffectRocketBoots;
